import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FoodGallerySection } from './components/FoodGallerySection';
import { MesaVivaSection } from './components/MesaVivaSection';
import { ComparisonTable } from './components/ComparisonTable';
import { ExperienceSection } from './components/ExperienceSection';
import { EventTypesSection } from './components/EventTypesSection';
import { WhyUsSection } from './components/WhyUsSection';
import { ServiceIncludesSection } from './components/ServiceIncludesSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-deep-brown" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <FoodGallerySection data-id="element-5" />
        <MesaVivaSection data-id="element-6" />
        <ComparisonTable data-id="element-7" />
        <ExperienceSection data-id="element-8" />
        <EventTypesSection data-id="element-9" />
        <WhyUsSection data-id="element-10" />
        <ServiceIncludesSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <CTASection data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
    </div>;
}